import { environment } from '../../../environments/environment';

export const API_CONFIG = {
  baseUrl: environment.apiGatewayUrl,
};
